import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../../Button'
import ClearButton from '../ClearButton'
import ButtonRow from '../ButtonRow'

export default (props) => (
  <>
    <ButtonRow>
      <Button as={Link} to='/results' small>
        Calculate
      </Button>
      <ClearButton {...props} />
    </ButtonRow>
    <ButtonRow justifyContent='space-between'>
      <Button as={Link} to='/monthly-costs' type='back' width='100px' small>
        Back
      </Button>
      <Button as={Link} to='/results' type='next' width='100px' small>
        Next
      </Button>
    </ButtonRow>
  </>
)
